<template>
	<c-dialog ref="dialog" mode="slide" width="80vw" mask-close enable-flex :resize-button="['max']" @close="closeConfirmHandle">
		<div class="m-batch-ship-body flex-column">
			<!-- 顶部扫码区 -->
			<div class="m-scan-toolbar flex-center-cross">
				<div class="m-scan-input-box">
					<c-input
						ref="stickerInput"
						v-model="produceCode"
						placeholder="先扫描或输入背贴码"
						@keyup.enter.native="scanHandle"
					></c-input>
					<i class="m-scan-icon tf tf-scan"></i>
				</div>
				<div class="m-scan-input-box">
					<c-input
						ref="qcInput"
						v-model="qcCode"
						placeholder="再扫描或输入质检码"
						@keyup.enter.native="scanHandle"
					></c-input>
				</div>
				<c-button color="main" @click="scanHandle">确定</c-button>
				<c-checkbox v-model="autoQcCode">切换扫码</c-checkbox>
			</div>

			<!-- 主内容区 -->
			<div class="m-main-area flex flex-grow">
				<!-- 左侧发货单列表 -->
				<div class="m-delivery-list">
					<div
						v-for="(delivery, index) in deliveryList"
						:key="delivery.id"
						:class="['m-delivery-card', { 'm-active': activeIndex === index }]"
						@click="changeActiveDelivery(index)"
					>
						<div class="m-card-index">{{index + 1}}</div>
						<div class="m-card-content">
							<div class="m-express-row">
								<label style="font-weight: bold;">运单号：</label>
								<template v-if="delivery.hasExpress && delivery.ship_state != 5">
									<span class="m-express-text">{{delivery.express_no || '-'}}</span>
								</template>
								<template v-else>
									<c-input v-model="delivery.edit_express_no" placeholder="请输入运单号"></c-input>
									<c-select
										v-model="delivery.edit_express_company_code"
										async
										@search="searchLogisticsCompany"
										:value-data="delivery.edit_express_company_data"
										placeholder="快递公司"
										@change="changeExpressCompany(delivery, $event)"
									></c-select>
								</template>
							</div>
							<div class="m-delivery-no">发货单号：{{delivery.delivery_no || delivery.id}}</div>
							<div class="m-delivery-count">
								<span>需发货：<b>{{delivery.ship_qty}}</b>件</span>
								<span class="m-scanned">已扫描：<b class="m-scanned-num">{{delivery.scanned_count}}</b>件</span>
							</div>
						</div>
					</div>
				</div>

				<!-- 右侧商品明细 -->
				<div class="m-item-table flex-grow flex-column">
					<c-table ref="list" :data="currentItemList" height="grow" :paging="false" empty-text="暂无待发货商品"
							 @rowClick="changeActiveItem">
						<c-table-column label="背贴码" width="180">
							<template #default="{data}">
								<span :class="{'m-active-item-code': isActiveItem(data)}">{{data.produce_code || '-'}}</span>
							</template>
						</c-table-column>
						<c-table-column label="产品信息" width="250">
							<template #default="{data}">
                                <c-state v-if="data.product_level" tag dict="LEVEL_TYPE" :value="data.product_level"></c-state>
                                <span>{{' ' + data.product_info || '-'}}</span>
							</template>
						</c-table-column>
						<c-table-column label="第三方质检码" width="180">
							<template #default="{data}">
								<div class="m-qc-cell">
									<span>{{data.qc_code || '-'}}</span>
									<c-table-button v-if="data.qc_code" icon="tf-print" @click="printQcLabel(data)">打印</c-table-button>
								</div>
							</template>
						</c-table-column>
						<c-table-column label="关联订单号" width="150">
							<template #default="{data}">{{data.order_no || '-'}}</template>
						</c-table-column>
						<c-table-column label="已扫数/需发货数" width="130" align="center">
							<template #default="{data}">
								<span class="m-count-text"><span class="m-scanned-count">{{data.scanned_count}}</span>/{{data.need_count}}</span>
							</template>
						</c-table-column>
						<c-table-column type="button" label="操作" width="80">
							<template #default="{data}">
								<c-table-button icon="tf-trash" color="red" @click="deleteScannedItem(data)">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</div>
			</div>

			<!-- 底部统计 -->
			<div class="m-footer-stat">
				共需发 <b>{{totalNeed}}</b> 件 · 已扫 <b>{{totalScanned}}</b> 件
			</div>
		</div>

		<template #button>
			<c-button size="dialog" color="main" :disabled="!canSubmit" @click="submitHandle">确认发货</c-button>
			<c-button size="dialog" @click="closeDialog">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'batchShipDialog',

		data() {
			return {
				deliveryList: [],
				activeIndex: 0,
				activeItemProduceCode: '',
				produceCode: '',
				qcCode: '',
				autoQcCode: false,
				isDirty: false,
				delivery_ids: []
			}
		},

        computed: {

			/*********当前选中的发货单**********/
			activeDelivery() {
				return this.deliveryList[this.activeIndex];
			},

			/*********当前展示的商品列表**********/
			currentItemList() {
				if (!this.activeDelivery) return [];
				return this.activeDelivery.items || [];
			},

			/*********总需发数量**********/
			totalNeed() {
				return this.deliveryList.reduce((sum, item) => sum + (parseInt(item.ship_qty) || 0), 0);
			},

			/*********总已扫数量**********/
			totalScanned() {
				return this.deliveryList.reduce((sum, item) => sum + (parseInt(item.scanned_count) || 0), 0);
			},

			/*********是否可以提交**********/
			canSubmit() {
				if (!this.deliveryList.length) return false;
				return this.deliveryList.every(item => item.scanned_count >= (parseInt(item.ship_qty) || 0));
			}
		},

		watch: {
			// 监听扫描数量变化，标记为已修改
			totalScanned() {
				this.isDirty = true;
			},
			// 监听运单号/快递公司编辑，标记为已修改
			deliveryList: {
				deep: true,
				handler() {
					this.isDirty = true;
				}
			}
		},

		methods: {
			/*********打开弹框**********/
			open(data = {}) {
				var ids = (data && data.ids) || [];
				if (!ids.length) {
					this.$message({message: '请先选择要发货的发货单', type: 'warn'});
					return;
				}
				this.deliveryList = [];
				this.delivery_ids = [];
				this.activeIndex = 0;
				this.activeItemProduceCode = '';
				this.produceCode = '';
				this.qcCode = '';
				this.autoQcCode = false;
				this.isDirty = false;
				// 重置赋值会触发 deliveryList 深度 watch，在 watcher flush 时误标 isDirty，待其执行后复原
				this.$nextTick(() => { this.isDirty = false; });

				// 先加载可发货数据，加载成功后再打开弹框：避免所选发货单不可发货时弹框一闪即关
				this.loadDetail(ids);
			},

            /*******异步搜索快递公司（LOGISTICS_TYPE字典，keyword映射后端name模糊查询）*******/
            searchLogisticsCompany(keyword, resolve) {
                this.request({
                    url: '/dic/info/options',
                    data: {
                        dic_type_code: 'LOGISTICS_TYPE',
                        name: keyword
                    },
                    success: data => {
                        resolve(data || []);
                    }
                });
            },

			/*********切换快递公司时同步名称（async下拉change回传完整选中项，清除时为空对象）**********/
			changeExpressCompany(delivery, data) {
				var valid = data && data.value !== undefined;
				delivery.edit_express_company_data = valid ? [data] : [];
				delivery.edit_express_company = valid ? (data.name || '') : '';
			},
			
			/*********加载批量发货详情**********/
			loadDetail(ids) {
				this.request({
					url: '/sale/delivery/batch/ship/detail',
					data: {
						ids: ids
					},
					loading: true,
					success: data => {
						// 加载成功后才打开弹框，规避不可发货时的空弹框闪现
						this.$refs.dialog.open({
							title: '发货'
						});
						this.initData(data);
					},
					// 加载失败（如所选发货单非待发货状态）时弹框尚未打开，仅提示原因，无需关闭
					fail: (code, obj, msg) => {
						this.$message({message: msg || '所选发货单不是“待发货”状态，无法执行批量发货', type: 'warn'});
						return false;
					}
				});
			},

			/*********初始化数据**********/
			initData(data) {
				var list = (data && data.delivery_list) || data || [];
				this.deliveryList = list.map(item => {
					var expressNo = item.express_no || '';
					var expressCompany = item.express_company || '';
					var expressCompanyCode = item.express_company_code || '';
					var hasExpress = !!(expressNo || expressCompany) && item.ship_state != 5;

					return {
						id: item.id,
						delivery_no: item.delivery_no || item.id,
						express_no: expressNo,
						express_company: expressCompany,
						express_company_code: expressCompanyCode,
						edit_express_no: hasExpress ? expressNo : '',
						edit_express_company: hasExpress ? expressCompany: '',
						edit_express_company_code: hasExpress ? expressCompanyCode: '',
						// 已选快递公司完整项[{name, value}]，用于async下拉的值回显
						edit_express_company_data: [],
						hasExpress: hasExpress,
                        ship_state: item.ship_state,
                        ship_qty: item.ship_qty,
                        product_level: item.product_level,
						scanned_count: 0,
                        waybill_type: item.waybill_type,
						items: []
					};
				});
                this.delivery_ids = list.map(item => {return item.id});

				// 默认选中第一个未扫描满的发货单
				var activeIndex = this.deliveryList.findIndex(item => item.scanned_count < (parseInt(item.ship_qty) || 0));
				this.activeIndex = activeIndex >= 0 ? activeIndex : 0;
				this.resetActiveItem();
				// 初始化赋值会触发 watch 误标 isDirty，待 watcher flush 后复原，避免未修改就关闭也弹二次确认
				this.$nextTick(() => { this.isDirty = false; });
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********重算发货单扫描数量**********/
			refreshDeliveryScannedCount(delivery) {
				var orderMap = {};
				delivery.items.forEach(item => {
					var orderScannedCount = delivery.items.filter(current => current.order_no == item.order_no).length;
					item.scanned_count = orderScannedCount;
					orderMap[item.order_no] = orderScannedCount;
				});
				delivery.scanned_count = Object.values(orderMap).reduce((sum, count) => sum + count, 0);
			},

			/*********打印质检码标签**********/
			printQcLabel(data) {
				this.printQcLabels([{
					qc_code: data.qc_code,
					product_info: data.product_info,
					imei: data.imei
				}]);
			},

			/*********删除已扫描商品**********/
			deleteScannedItem(data) {
				var delivery = this.activeDelivery;
				if (!delivery) return;
				var index = delivery.items.findIndex(item => item.produce_code == data.produce_code);
				if (index < 0) return;
				delivery.items.splice(index, 1);
				this.refreshDeliveryScannedCount(delivery);
				if (this.activeItemProduceCode == data.produce_code) {
					this.resetActiveItem();
				}
				this.isDirty = true;
				this.focusStickerInput();
			},

			/*********切换当前发货单**********/
			changeActiveDelivery(index) {
				this.activeIndex = index;
				this.resetActiveItem();
			},

			/*********切换当前质检码目标商品**********/
			changeActiveItem({data}) {
				var items = (this.activeDelivery && this.activeDelivery.items) || [];
				if (items.some(item => item.produce_code == data.produce_code)) {
					this.activeItemProduceCode = data.produce_code;
				}
			},

			isActiveItem(data) {
				return data && data.produce_code == this.activeItemProduceCode;
			},

			/*********重置当前发货单的质检码目标商品**********/
			resetActiveItem() {
				var items = (this.activeDelivery && this.activeDelivery.items) || [];
				var item = items.find(item => !item.qc_code) || items[0];
				this.activeItemProduceCode = item ? item.produce_code : '';
			},

			/*********获取当前质检码目标商品**********/
			getActiveQcItem() {
				var items = (this.activeDelivery && this.activeDelivery.items) || [];
				return items.find(item => item.produce_code == this.activeItemProduceCode)
					|| items.find(item => !item.qc_code)
					|| items[0];
			},

			/*********录入/覆盖质检码**********/
			handleQcCode(qcCode) {
				var item = this.getActiveQcItem();
				if (item) {
					var items = this.activeDelivery.items;
					var index = items.findIndex(current => current.produce_code == item.produce_code);
					items.splice(index, 1, Object.assign({}, item, {qc_code: qcCode}));
					this.qcCode = '';
					this.isDirty = true;
				}
				this.focusStickerInput();
			},

			/*********扫码处理**********/
			scanHandle() {
				if (!this.deliveryList.length) {
					this.$message({message: '没有可发货的发货单，请重新选择后再扫码', type: 'warn'});
					return;
				}

				var produceCode = this.produceCode.trim();
				var qcCode = this.qcCode.trim();
				if (qcCode && !produceCode) {
					this.handleQcCode(qcCode);
					return;
				}

				if (!produceCode) {
					this.$message({message: '请扫描或输入背贴码', type: 'warn'});
					return;
				}

				for (var i = 0; i < this.deliveryList.length; i++) {
					var delivery = this.deliveryList[i];
					for (var item of (delivery.items || [])) {
						var matchSticker = item.produce_code == produceCode;
						if (matchSticker) {
                            this.$message({message: '该商品已扫描', type: 'warn'});
                            this.clearScanInput();
                            return;
						}
					}
				}

                this.request({
                    url: '/sale/delivery/scan/product',
                    data: {
                        produce_code: this.produceCode,
                        delivery_ids: this.delivery_ids
                    },
                    loading: true,
                    success: (data) => {
                        if (!data) {
                            this.$message({message: '商品不存在或不属于当前发货单，请检查', type: 'warn'});
                            this.clearScanInput();
                            return;
                        }
                        // 找到对应的发货单
                        var delivery = this.deliveryList.find(d => d.id == data.delivery_id);
                        if (!delivery) {
                            this.$message({message: '未找到对应的发货单', type: 'warn'});
                            this.clearScanInput();
                            return;
                        }

                        // 查找该商品是否已存在于items中
                        var existItem = delivery.items.find(item => item.produce_code == data.produce_code && item.qc_code == data.qc_code);
                        if (existItem) {
                            // 已存在，无需重复添加
                            this.$message({message: '该商品已扫描', type: 'warn'});
                            this.clearScanInput();
                            return;
                        }

                        // 新商品，添加到items中
                        delivery.items.push({
                            produce_code: data.produce_code,
                            product_info: data.product_name || '-',
                            order_no: data.order_no,
                            order_id: data.order_id,
                            imei: data.imei,
                            product_level: data.product_level || data.level_type,
                            need_count: parseInt(data.order_product_count) || 1,
                            scanned_count: 0,
                            // 订单自带三方质检码时先回填，后续再扫质检码会覆盖
                            qc_code: qcCode || data.qc_code || ''
                        });
						this.refreshDeliveryScannedCount(delivery);
						// 激活对应发货单
						this.activeIndex = this.deliveryList.indexOf(delivery);
						this.activeItemProduceCode = data.produce_code;
						this.isDirty = true;
						this.clearScanInput(this.autoQcCode);
                    },
                    fail: (code, obj, msg) => {
                        this.$message({message: msg || '商品不存在或不属于发货单，请检查', type: 'warn'});
                        return false;
                    }
                })

				// this.clearScanInput();
			},

			/*********清空扫码输入**********/
			clearScanInput(focusQcCode = false) {
				this.produceCode = '';
				this.qcCode = '';
				if (focusQcCode) {
					this.focusQcInput();
				} else {
					this.focusStickerInput();
				}
			},

			/*********聚焦背贴码输入框**********/
			focusStickerInput() {
				this.$nextTick(() => {
					var input = this.$refs.stickerInput && this.$refs.stickerInput.$el.querySelector('input');
					if (input) input.focus();
				});
			},

			/*********聚焦质检码输入框**********/
			focusQcInput() {
				this.$nextTick(() => {
					var input = this.$refs.qcInput && this.$refs.qcInput.$el.querySelector('input');
					if (input) input.focus();
				});
			},

			/*********提交发货**********/
			submitHandle() {
				if (!this.canSubmit) {
					// 找出未扫描满的发货单，提示具体单号
					var incomplete = this.deliveryList.find(item => item.scanned_count < (parseInt(item.ship_qty) || 0));
					var msg = incomplete
						? '发货单 ' + (incomplete.delivery_no || incomplete.id) + ' 尚未扫描完成（' + incomplete.scanned_count + '/' + incomplete.ship_qty + '）'
						: '请扫描完所有发货单的商品';
					this.$message({message: msg, type: 'warn'});
					return;
				}

				var submitList = this.deliveryList.map(item => {
					var hasExpress = item.hasExpress;
					return {
						delivery_id: item.id,
                        delivery_no: item.delivery_no,
						express_no: hasExpress ? item.express_no : item.edit_express_no,
						express_company: hasExpress ? item.express_company : item.edit_express_company,
						express_company_code: hasExpress ? item.express_company_code : item.edit_express_company_code,
						waybill_type: hasExpress ? 1 : 2,
                        items: item.items.map(item2 => {
                            return {
                                order_id: item2.order_id,
                                qc_code: item2.qc_code,
                                produce_code: item2.produce_code
                            };
                        })
					};
				});

				// 校验无面单模式必须填写运单号和快递公司
				for (var delivery of submitList) {
					var original = this.deliveryList.find(item => item.id == delivery.delivery_id);
					if (!original.hasExpress) {
						if (!delivery.express_no || !delivery.express_no.trim()) {
							this.$message({message: '请填写所有无面单发货单的运单号', type: 'warn'});
							return;
						}
						if (!delivery.express_company) {
							this.$message({message: '请选择所有无面单发货单的快递公司', type: 'warn'});
							return;
						}
					}
				}

				this.request({
					url: '/sale/delivery/batch/ship',
					data: {
						deliveries: submitList
					},
					loading: true,
					success: (data, msg) => {
                        var notice = true
						if (data.totalCount > 0) {
							var failedDeliveries = (data.details || []).filter(item => item.delivery_result === 2 || item.delivery_result === 3);
							this.isDirty = false;
							this.$refs.dialog.close();
							this.$emit('resolve');
							if (failedDeliveries.length) {
                                notice = false
								var deliveryNos = failedDeliveries.map(item => item.delivery_no || item.delivery_id).join('、');
								this.$nextTick(() => {
									this.$confirm({
										type: 'warn',
										title: '存在发货失败订单',
										message: '发货单【' + deliveryNos + '】存在部分或全部发货失败的订单，请在列表中点击“发货详情”查看失败原因。',
										buttonName: '了解',
										cancelButton: false,
										resolve: () => {}
									});
								});
							}
                        }
                        if (notice) {
                            this.$message({message: msg || '批量发货完成', type: data.failCount > 0 ? 'warning' : 'success'});
                        }
					}
				});
			},

			/*********关闭弹框确认（有修改时二次确认）**********/
			closeConfirmHandle(preventDefault, confirmClose) {
				if (!this.isDirty) return;
				preventDefault();
				this.$confirm({
					message: '关闭后已更改的数据将会丢失，确定要关闭吗？',
					cancelButtonName: '继续编辑',
					resolve: () => {
						this.isDirty = false;
						confirmClose();
					}
				});
			},

			/*********关闭弹框**********/
			closeDialog() {
				this.$refs.dialog.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-batch-ship-body {
		height: 100%;
		overflow: hidden;

		::v-deep .c-dialog-body {
			padding: 0;
		}
	}

	.m-scan-toolbar {
		padding: 12px 16px;
		gap: 12px;
		border-bottom: 1px solid #e8e8e8;
		background: #fafafa;

		.m-scan-input-box {
			position: relative;
			width: 260px;

			::v-deep .c-input input {
				background: #fffbe6;
			}

			.m-scan-icon {
				position: absolute;
				right: 10px;
				top: 50%;
				transform: translateY(-50%);
				font-size: 16px;
				color: #999;
			}
		}
	}

	.m-main-area {
		min-height: 0;
	}

	.m-delivery-list {
		width: 380px;
		border-right: 1px solid #e8e8e8;
		overflow-y: auto;
		background: #f5f7fa;
		padding: 16px;

		.m-delivery-card {
			position: relative;
			padding: 10px 8px 8px 20px;
			margin-bottom: 16px;
			background: #fff;
			border: 1px solid #e8e8e8;
			border-radius: 6px;
			cursor: pointer;
			transition: all 0.2s;

			&.m-active {
				border-color: #1890ff;
				box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
			}

			.m-card-index {
				position: absolute;
				left: 0;
				top: 0;
				width: 18px;
				height: 18px;
				line-height: 18px;
				text-align: center;
				background: #1890ff;
				color: #fff;
				border-radius: 4px 0 4px 0;
				font-size: 10px;
			}

			.m-card-content {
				.m-express-row {
					display: flex;
					align-items: center;
					gap: 10px;
					margin-bottom: 10px;

					label {
						font-size: 14px;
						color: #333;
						font-weight: 500;
						white-space: nowrap;
					}

					.m-express-text {
						font-size: 14px;
						color: #333;
						font-weight: 500;
					}

					::v-deep .c-input {
						width: 170px;
						height: 28px;

						input {
							height: 28px;
							line-height: 28px;
							padding: 0 8px;
							font-size: 13px;
						}
					}

					::v-deep .c-select {
						width: 110px;
						height: 28px;

						.c-select__input {
							height: 28px;
							line-height: 28px;
							font-size: 13px;
						}
					}
				}

				.m-delivery-no {
					font-size: 12px;
					color: #666;
					line-height: 20px;
				}

				.m-delivery-count {
					margin-top: 6px;
					font-size: 13px;
					color: #666;
					line-height: 24px;

					.m-scanned {
						margin-left: 16px;
					}

					b {
						font-size: 16px;
						font-weight: bold;
						color: #333;
					}

					.m-scanned-num {
						color: #f5222d;
					}
				}
			}
		}
	}

	.m-item-table {
		overflow: hidden;
		padding: 12px;

		::v-deep .c-table {
			border: 1px solid #e8e8e8;
			border-radius: 4px;
		}

		::v-deep .c-table-body table tbody tr.z-hl td {
			background: #e6f7ff !important;
		}

		.m-active-item-code {
			color: #1890ff;
			font-weight: 600;
		}

		.m-active-item-tag {
			display: inline-block;
			margin-left: 6px;
			padding: 0 4px;
			border-radius: 2px;
			font-size: 11px;
			line-height: 18px;
			color: #fff;
			background: #1890ff;
		}

		.m-product-tag {
			display: inline-block;
			padding: 0 6px;
			margin-right: 6px;
			border-radius: 2px;
			font-size: 12px;
			line-height: 18px;
			color: #1890ff;
			background: #e6f7ff;
			border: 1px solid #91d5ff;
		}

		.m-count-text {
			color: #333;
			font-weight: 500;

			.m-scanned-count {
				color: #52c41a;
			}
		}
	}

	.m-qc-cell {
		display: flex;
		align-items: center;
	}

	.m-footer-stat {
		padding: 10px 16px;
		border-top: 1px solid #e8e8e8;
		background: #fafafa;
		font-size: 18px;
		color: #666;

		b {
			color: #1890ff;
		}
	}
</style>
